import PayrollWelfareComponents from "../components/PayrollWelfare";
import useWelfareList from "../hooks/useWelfareList";

const PayrollWelfare = () => {
  const useWelfareListProps = useWelfareList();
  return <PayrollWelfareComponents {...useWelfareListProps} />;
};

export default PayrollWelfare;
